import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenExpiredService } from '../services/token-expired.service';

export const loginGuard: CanActivateFn = async (state) => { 
  const router = inject(Router);
	const tokenExpired = inject(TokenExpiredService);

	let beLoggedIn: boolean;

	await tokenExpired.guardTokenExpired().then(res => {
		beLoggedIn = res;
	})

	const queryParams = { redirectUrl: state.url };

	Object.keys(state.root.queryParams).forEach(key => {
		queryParams[key] = state.root.queryParams[key];
	});

	if (!beLoggedIn) {
		// Redirect to the login page
		router.navigate(['login'], { queryParams: queryParams });
	}
	return beLoggedIn
};

